const url = new URL(location.href);

const config = {
  apiHost: process.env.VUE_APP_TITLE,
  yandexMetrikaId: url.searchParams.get('metrikaId'),
  roistatVisit: url.searchParams.get('roistatVisit'),
  onlyBar: url.searchParams.get('onlyBar'),
};

export default config;
